import { API } from "../../Services";

export const trelloBoards = () =>{
    return (dispatch) =>{
        dispatch({
            type:"FETCH_TRELLO_BOARDS",
        })
         API.trelloBoards().then((res)=>{
            let data = JSON.parse(JSON.stringify(res)).data.board
            setTimeout(()=>{
                dispatch({
                    type:"RECEIVE_TRELLO_BOARDS",
                    payload:data,
                })
            },1000)
        }).catch((err)=>{
            dispatch({
                type:"ERROR_TRELLO_BOARDS",
            })
        })
    }
}